import {
  CriteriaWithPagination,
  EuiBasicTable,
  EuiBasicTableColumn,
  EuiButtonIcon,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
  Pagination,
} from "@elastic/eui";
import { Divider, Text } from "@mantine/core";
import { useState, useCallback } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrEmpty,
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import AppSearch from "../../../common/AppSearch";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblCollectionForm } from "../../../model/TblCollectionForm";

const ArticleEmail = () => {
  const columns: Array<EuiBasicTableColumn<any>> = [
    {
      field: "id",
      name: "ID",
      sortable: true,
      truncateText: true,
      width: "3%",
    },
    {
      field: "",
      name: "Khách hàng",
      sortable: true,
      width: "22%",
      truncateText: true,
      render: (online: TblCollectionForm) => (
        <p>
          {online.fullname} ({online.email})
        </p>
      ),
    },
    {
      field: "productName",
      name: "Sản phẩm",
      sortable: true,
      truncateText: true,
      render: (productName: string) => (
        <Text w={"100%"} truncate>
          {productName}
        </Text>
      ),
    },
    {
      field: "creationDate",
      name: "Thời gian",
      sortable: true,
      truncateText: true,
      width: "10%",
      render: (date: string) => (
        <Text w={"100%"} truncate>
          {date}
        </Text>
      ),
    },
    {
      name: "Actions",
      width: "5%",
      render: (online: TblCollectionForm) => {
        return (
          <>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
            >
              <EuiFlexItem grow={false}>
                <EuiButtonIcon
                  iconType="documentEdit"
                  aria-label="Dashboard"
                  color="success"
                  onClick={() => {
                    NotificationExtension.Warn("Chức năng này đã bị tắt!");
                  }}
                />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <EuiButtonIcon
                  iconType="trash"
                  color="danger"
                  onClick={() => {
                    NotificationExtension.Warn("Chức năng này đã bị tắt!");
                  }}
                />
              </EuiFlexItem>
            </EuiFlexGroup>
          </>
        );
      },
    },
  ];

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<Pagination>(paginationBase);
  const [paramSearch] = useState<ParamSearchBase>();
  const [datas, setDatas] = useState<TblCollectionForm[]>([]);

  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({
      ...pagination,
      pageIndex: index,
      pageSize: size,
      totalItemCount: 1000,
    });
  };

  const onChange = () => {};
  const onChangeText = () => {};

  const fetchDataCollectionForm = useCallback(
    async (
      index: number,
      size?: number,
      keyWord?: string,
      inActive?: boolean
    ) => {
      setLoading(true);
      setError(undefined);
      const repository = new Repository(
        process.env.REACT_APP_Demo_APP_API_URL2
      );
      try {
        let urlSearch = `${API_ROUTE.GET_LIST_COLLECTION_FORM}?Skip=${
          index * (size ?? 0)
        }&Take=${size}`;
        if (!isNullOrEmpty(keyWord))
          urlSearch = urlSearch + `&KeySearch=` + keyWord;
        let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
        if (
          isNullOrUndefined(callapi) ||
          isNullOrUndefinedArry(callapi?.data)
        ) {
          setDatas([]);
        } else {
          setDatas(callapi?.data ?? []);
          setPagination({
            ...pagination,
            totalItemCount: callapi?.totalCount ?? 0,
          });
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        return null;
      } finally {
        setLoading(false);
      }
    },
    [pagination]
  );

  return (
    <>
      <AppAction />
      <Divider my="sm" />
      <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() =>
          fetchDataCollectionForm(
            pagination.pageIndex,
            pagination.pageSize,
            paramSearch?.keyWord,
            paramSearch?.inActive
          )
        }
      />
      <EuiSpacer size="l" />
      <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      />
    </>
  );
};

export default ArticleEmail;
